/**
 * Post types that correspond to SocialPostType from the GraphQL schema
 */
export type PostType =
  | 'INSTAGRAM_POST'
  | 'INSTAGRAM_REEL'
  | 'INSTAGRAM_STORY'
  | 'PINTEREST_PIN'
  | 'TIKTOK_VIDEO'
  | 'YOUTUBE_SHORT'
  | 'YOUTUBE_VIDEO';

/**
 * Human-readable labels for post types
 */
export const POST_TYPE_LABELS: Record<PostType, string> = {
  INSTAGRAM_POST: 'Instagram Post',
  INSTAGRAM_REEL: 'Instagram Reel',
  INSTAGRAM_STORY: 'Instagram Story',
  PINTEREST_PIN: 'Pinterest Pin',
  TIKTOK_VIDEO: 'TikTok Video',
  YOUTUBE_SHORT: 'YouTube Short',
  YOUTUBE_VIDEO: 'YouTube Video',
};

/**
 * Map API entityType strings to PostType enum values
 */
export const ENTITY_TYPE_TO_POST_TYPE: Record<string, PostType> = {
  'instagram_post': 'INSTAGRAM_POST',
  'instagram_reel': 'INSTAGRAM_REEL',
  'instagram_story': 'INSTAGRAM_STORY',
  'pinterest_pin': 'PINTEREST_PIN',
  'tiktok_video': 'TIKTOK_VIDEO',
  'youtube_short': 'YOUTUBE_SHORT',
  'youtube_video': 'YOUTUBE_VIDEO',
};
